export const ENDPOINTS = {
    getAllPeriods: "/getEmissionsAllPeriods",
    getSinglePeriodForecasts: "/getEmissionsForecastsForPeriod",
    calculateResults: "/calculateResults",
    createClassificationQueue: "/createClassificationQueue",
    purgeClassificationQueue: "/purgeClassificationQueue",
    endPurchaseClassification: "/endPurchaseClassification",
}
